import { Component } from '@angular/core';
import { faCoffee, faSdCard, faUsers } from '@fortawesome/free-solid-svg-icons';
import { faStar as farStar } from '@fortawesome/free-regular-svg-icons';
import { Config } from './config';
import {SharedService} from '../app/shared/services/shared.service';

@Component({
  providers: [SharedService],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  title = 'ist-ws2';
  faCoffee = faCoffee;
  faUser = faUsers;
}
